import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HomeImageService } from 'src/app/shared/API-Service/services/HomeImage.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-create-or-update-home-image',
  templateUrl: './create-or-update-home-image.component.html',
  styleUrls: ['./create-or-update-home-image.component.css'],
  
})
export class CreateOrUpdateHomeImageComponent implements OnInit {
  DesktopImage: File;
  DesktopimageLogo: string;
  Desktopimg : any = Image;


  IpadImage: File;
  IpadimageLogo: string;
  Ipadimg : any = Image;


  IpadportraitImage: File;
  IpadportraitimageLogo: string;
  Ipadportraitimg : any = Image;



  MobileImage: File;
  MobileimageLogo: string;
  Mobileimg : any = Image;

  HomeImageForm : FormGroup;
  HomeImageFormData : FormData
  button: boolean;
  update: boolean;
  HomeImageData: any;
  id: any;
  constructor(private _Router:Router,private _FormBuilder:FormBuilder,private HomeImageService:HomeImageService) { 
    this.initiate();
  }

  ngOnInit(): void {
      this.HomeImageService.GetWebImageList().subscribe(async (res:any)=>{
        console.log(res.data);
      this.HomeImageData=  await res.data;
      this.id =this.HomeImageData.id;

      this.DesktopimageLogo=environment.ServerImages_URL+'/'+this.HomeImageData.desktop
      this.IpadimageLogo=environment.ServerImages_URL+'/'+this.HomeImageData.ipad
      this.IpadportraitimageLogo=environment.ServerImages_URL+'/'+this.HomeImageData.ipadportrait
      this.MobileimageLogo=environment.ServerImages_URL+'/'+this.HomeImageData.mobile
this.initiate(this.HomeImageData);
        
      })
      this.update = true;
    
 
  }
  getLogoUrlDesktop(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.DesktopImage = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.DesktopimageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
      };
    }
  }


  getLogoUrlIpad(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.IpadImage = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.IpadimageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
      };
    }
  }



  getLogoUrlIpadportrait(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.IpadportraitImage = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.IpadportraitimageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
      };
    }
  }




  getLogoUrlMobile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.MobileImage = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.MobileimageLogo = reader.result as string;
        // this.logoForm?.append("image", this.Image);
      };
    }
  }
  updateappenddata(){
    this.HomeImageFormData = new FormData();
    if (this.DesktopImage) this.HomeImageFormData.append("Desktop", this.DesktopImage);
    if (this.IpadImage) this.HomeImageFormData.append("Ipad", this.IpadImage); 
    if (this.IpadportraitImage) this.HomeImageFormData.append("Ipadportrait", this.IpadportraitImage);
    if (this.MobileImage) this.HomeImageFormData.append("Mobile", this.MobileImage);

    this.HomeImageFormData.append("Id", this.id);
  }
  insertappenddata(){
    this.HomeImageFormData = new FormData();
    if (this.DesktopImage) this.HomeImageFormData.append("Desktop", this.DesktopImage);
    if (this.IpadImage) this.HomeImageFormData.append("Ipad", this.IpadImage); 
    if (this.IpadportraitImage) this.HomeImageFormData.append("Ipadportrait", this.IpadportraitImage);
    if (this.MobileImage) this.HomeImageFormData.append("Mobile", this.MobileImage);
  }
  initiate(HomeImage?:any){

    this.HomeImageForm = this._FormBuilder.group({
      Desktop: [HomeImage?.desktop||'', Validators.required],
      Ipad: [HomeImage?.ipad||'', Validators.required],
      Ipadportrait: [HomeImage?.ipadportrait||'', Validators.required],
      Mobile: [HomeImage?.mobile||'', Validators.required],
    });
  }
  onSubmit(){
    this.button = true;
    
   if(this.update == false && this.HomeImageForm.status == "VALID"){
    
    this.insertappenddata();
    
    this.HomeImageService.CreateOrUpdateImage(this.HomeImageFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح  ",
        showConfirmButton: false,
        timer: 1500,
      });
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
      this.button = false ;
    }, () => {
      console.log('completed ');
    })
   } else if(this.HomeImageForm.status == "VALID"){
     this.updateappenddata();
    this.HomeImageService.CreateOrUpdateImage(this.HomeImageFormData).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.message    
      }) 
    }, () => {
      console.log('completed ');
    })
   }
   else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.HomeImageForm.markAllAsTouched();
    this.button = false;
   }
  }
}
